module.exports = __webpack_public_path__ + "static/ms-icon-144x144-7abf421ea38a783bc27c83db038994d1.png";